// Regex which matches a valid file name.
export const fileNameRegex = /^[\w\-][\w\- ]*$/;
